export const restServices = {
  authenticate: 'authenticate',
  richiediAssistenza: 'richiedi-assistenza',
  users: 'users',
  utentiLdap: 'utenti-ldap',
  gruppiLdap: 'gruppi-ldap',
  simulazione: 'simulazione',
  dominioCross: 'dominio-crosses',
  cambi: 'cambi',
  pricing: 'pricing',
  pricingDerivatiCambi: 'pricing-derivati-cambi',
  exportPricingOutputExcel: 'export-pricing-output-excel',
  getSpotByCross: 'get-spot-by-cross',
  calcoloTassiDeposito: 'calcolo-tassi-deposito',
  salvaSessionePricingDerivatiCambi: 'salva-sessione-pricing-derivati-cambi',
  getSessioniPricingDerivatiCambi: 'get-sessioni-pricing-derivati-cambi',
  uploadExcelPricingDerivatiCambi: 'upload-excel-pricing-derivati-cambi',
  calcolaVolatilita: 'calcola-volatilita',
  eliminaSessione: 'elimina-sessione',
  funzioneApplicazione: 'funzione-applicazione',
  qlikApps: 'qlik-apps',
  dominioEsposizioneNettas: 'dominio-esposizione-nettas',
  dominioAggregaziones: 'dominio-aggregaziones',
  dominioValutas: 'dominio-valutas',
  scenarios: 'scenarios',
  calcolaSpotFv: 'calcola-spot-fv',
  tenant: 'tenant',
  fileModellos: 'file-modellos',
  strumentiUtilizzabili: 'strumenti-utilizzabili',
  marketStrumenti: 'market-strumenti',
  updateNumeroDownload: 'update-numero-download',
  noContent: 'no-content',
  richiediInformazioni: 'richiedi-informazioni',
  disable: 'disable',
  enable: 'enable',
  cambioObiettivo: 'cambio-obiettivo',
  cambioBce: 'cambio-bce'
};
